import Marionette from "../../shared/marionette-mustache";
import { BrowsePanelView } from "../../browse/views/browse-panel";
import { BrowsePanelModel } from "../../browse/models/browse-panel";
import { backboneViewProperties } from "../../decorators/backbone-properties";
const controlsTemplate = require<string>("../views/controls-panel.html");
const panelTemplate = require<string>("../views/browse-panel.html");

@backboneViewProperties({
    childView : BrowsePanelView
})
export class BrowsePanelsCollection extends Marionette.CollectionView<BrowsePanelModel, BrowsePanelView> {
    constructor(options?: Marionette.CollectionViewOptions<BrowsePanelModel>) {
        super(options);
    }

    public buildChildView(childModel: BrowsePanelModel) {
        let template;
        switch (childModel.SelectedType) {
            case "material":
                template = controlsTemplate;
                break;
           default:
                template = panelTemplate;
                break;
        }
        return new BrowsePanelView({model: childModel, template});
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/browse/collections/browse-panels.ts